import { connect } from 'react-redux';

import { IAppState, Dispatch } from '../../../../../../../common/state';
import { EWindowsType } from '../../../../../../../json_query';
import { changeWindowsType } from '../../../../../../state/advanced/windows';
import { changeBalconies } from '../../../../../../state/advanced/balconies';

import { Windows as WindowsComponent } from './windows';

export function mapStateToProps(state: IAppState) {
  return {
    windows: state.filters.jsonQuery.windows_type ? state.filters.jsonQuery.windows_type.value : EWindowsType.Any,
    withBalconies: !!(
      (state.filters.jsonQuery.balconies && state.filters.jsonQuery.balconies.value.gte) ||
      (state.filters.jsonQuery.loggia && state.filters.jsonQuery.loggia.value)
    ),
  };
}

export function mapDispatchToProps(dispatch: Dispatch) {
  return {
    onWindowsChange: (value: EWindowsType) => {
      dispatch(changeWindowsType(value));
    },
    onBalconiesChange: (value: boolean) => {
      dispatch(changeBalconies(value));
    },
  };
}

export const Windows = connect(mapStateToProps, mapDispatchToProps)(WindowsComponent);
